// @ts-strict-ignore
import { Component } from '@angular/core';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectComponentPresenter } from '../../../project-component.presenter';

@Component({
  standalone: false,
  selector: 'app-elbridge-info',
  templateUrl: './elbridge-info.component.html',
})
export class ElbridgeInfoComponent {
  constructor(private bsModalRef: BsModalRef,
              private localeResourceManager: LocaleResourceManager,
              private projectComponentPresenter: ProjectComponentPresenter,
  ) {
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public openInfoLink(): void {
    window.open(this.localeResourceManager.getValueByKey('elbridge.info.link.href'));
  }

  public submit(): void {
    this.projectComponentPresenter.openElbridgeDialog();
    this.close();
  }
}
